import { computed, onMounted, onUnmounted, ref } from 'vue'

const MOBILE_MAX_WIDTH = 599
const TABLET_MAX_WIDTH = 1024
const WIDESCREEN_DOWN = 1199

export function useDevice() {
  const vssWidth = ref(null)
  const vssHeight = ref(null)
  const vssClientHeight = ref(null)

  const getScreenWidth = () =>
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth

  const getScreenHeight = () =>
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.body.clientHeight

  const getClientHeight = () =>
    typeof visualViewport !== 'undefined'
      ? visualViewport.height
      : null

  const handleResize = () => {
    vssWidth.value = getScreenWidth()
    vssHeight.value = getScreenHeight()
  }

  const clientHeightResize = () => {
    vssClientHeight.value = getClientHeight()
  }

  const hasVisualViewport = computed(() => typeof visualViewport !== 'undefined')

  const isMobile = computed(() => vssWidth.value <= MOBILE_MAX_WIDTH)
  const isTablet = computed(() => vssWidth.value <= TABLET_MAX_WIDTH)
  const isWidescreenDown = computed(() => vssWidth.value <= WIDESCREEN_DOWN)
  const clientHeight = computed(() => getClientHeight())

  onMounted(() => {
    handleResize()
    window.addEventListener('resize', handleResize)

    if (hasVisualViewport.value) {
      visualViewport.addEventListener('resize', clientHeightResize)
    }
  })

  onUnmounted(() => {
    window.removeEventListener('resize', handleResize)

    if (hasVisualViewport.value) {
      visualViewport.removeEventListener('resize', clientHeightResize)
    }
  })

  return {
    // state
    vssWidth,
    vssHeight,
    vssClientHeight,

    // computed
    isMobile,
    isTablet,
    isWidescreenDown,
    clientHeight,
    hasVisualViewport,

    // helpers if needed
    getScreenWidth,
    getScreenHeight,
    getClientHeight
  }
}
